import React, { useState, useContext } from 'react'
import './login.css'
import { IconButton, useMediaQuery } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { M_Button, M_InputTextField, LoadingBar, BufferService, M_MessageBoard, LoadingContext } from 'src/M_Components'
import HeaderLogin from '../headerLogin/headerLogin'
import EmailIcon from '@mui/icons-material/Email'
import KeyIcon from '@mui/icons-material/Key'

export default function Login({ t }) {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const bufferService = new BufferService('identity/login')
  const forgotService = new BufferService('identity/forgetpassword')
  const [loading, setLoading] = useState(false)
  const [forgotPass, setForgotPass] = useState(false)
  const [imageNumber, setImageNumber] = useState(getRandomInt(2, 5))
  const navigate = useNavigate()
  const match1 = useMediaQuery('(max-width: 1400px)')
  const match2 = useMediaQuery('(max-width: 1000px)')
  const match3 = useMediaQuery('(max-height: 825px)')
  const match4 = useMediaQuery('(max-height: 660px)')
  const match5 = useMediaQuery('(max-height: 700px)')
  const match6 = useMediaQuery('(max-height: 670px)')

  const ctx = useContext(LoadingContext)
  versionControl()
  const handleSubmit = () => {
    setLoading(true)

    //* BYPASS LOGIN - Mock authentication for GenericEntity testing
    // Simulate successful login with fake token and user data
    const fakeToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkZXZsb3BAZGV2bG9wLnN5c3RlbXMiLCJuYW1lIjoiRGV2ZWxvcCBBZG1pbiIsInJvbGVzIjpbIkdlbmVyaWNFbnRpdHkgQWRtaW4gTGlzdCIsIkdlbmVyaWNFbnRpdHkgVXNlciBMaXN0Il0sImV4cCI6OTk5OTk5OTk5OX0.fake'
    const fakeUserProfile = {
      UserId: 1,
      Name: "Devlop Admin",
      Email: email || "devlop@devlop.systems",
      Roles: ["GenericEntity Admin List", "GenericEntity User List"],
      Permissions: [
        "GenericEntity Admin List",
        "GenericEntity Admin Create", 
        "GenericEntity Admin Edit",
        "GenericEntity Admin Delete",
        "GenericEntity User List",
        "GenericEntity User Create",
        "GenericEntity User Edit",
        "GenericEntity User Delete"
      ]
    }

    localStorage.setItem('tokenMaeil', fakeToken)
    localStorage.setItem('userProfile', JSON.stringify(fakeUserProfile))
    
    ctx.toastMessages('success', t("AlertMessageSucessLogged"))
    setTimeout(() => {
      navigate(`/home`)
      setLoading(false)
    }, 500)

    //* ORIGINAL CODE - Commented for bypass
    // const user = {
    //   "email": email,
    //   "password": password
    // }
    // bufferService.post(user).then(response => {
    //   if (response.name === 'AxiosError') {
    //     ctx.toastMessages('error', response?.response?.data?.Errors ? response.response.data.Errors.toString() : t("AlertMessageBadLogin"))
    //     setLoading(false)
    //     return
    //   }
    //   localStorage.setItem('tokenMaeil', response.Token)
    //   ctx.toastMessages('success', t("AlertMessageSucessLogged"))
    //   navigate(`/home`)
    //   setLoading(false)
    // })
  }

  async function versionControl() {
    const newVersion = await fetch('/version.txt')
    const oldVersion = localStorage.getItem('version')
    const versionText = await newVersion.text()

    if (versionText != oldVersion) {
      window.location.reload(true)
      localStorage.setItem('version', versionText)
    }
  }

  const companyButtons = [
    {
      label: "Facebook",
      link: "https://www.facebook.com/devlop.systems",
      src: "/icons/socialIcons/Facebook.svg"
    },
    {
      label: "Instagram",
      link: "https://www.instagram.com/devlop.systems/",
      src: "/icons/socialIcons/Instagram.svg"
    },
    {
      label: "Linkedin",
      link: "https://www.linkedin.com/company/devlop-systems/mycompany/",
      src: "/icons/socialIcons/Linkedin.svg"
    },
    {
      label: "Youtube",
      link: "https://www.youtube.com/@devlopsystems",
      src: "/icons/socialIcons/Youtube.svg"
    },
  ]

  const onClickButton = (url) => {
    window.open(url, '_blank')
  }

  const onForgotPass = () => {
    ctx.setIsLoad(true)
    const tempObj = {
      email: email
    }
    forgotService.update('', tempObj).then(res => {
      ctx.setIsLoad(false)
      if (res.name === 'AxiosError') {
        ctx.toastMessages('error', res?.response?.data?.Errors ? res.response.data.Errors.toString() : t("AlertMessageBadLogin"))
        return
      }
      ctx.toastMessages('success', 'Success! An email was sent to this account with your new password!')
      setForgotPass(false)
    })
    // ctx.toastMessages('')

  }

  function getRandomInt(min, max) {
    const minCeiled = Math.ceil(min);
    const maxFloored = Math.floor(max);
    return Math.floor(Math.random() * (maxFloored - minCeiled) + minCeiled); // The maximum is exclusive and the minimum is inclusive
  }


  return (
    <div style={{
      width: '100vw',
      height: '100vh',
      overflow: 'hidden',
      display: 'flex'
    }}>

      {!match2 && <div style={{
        height: '100vh',

      }}>

        {!loading && <img
          src={`/images/images/vesselmf${imageNumber}.png`}
          alt={'PSL'}
          height={'100%'}
          style={{
            display: 'block',
            marginLeft: 'auto',
            marginRight: 'auto',
            width: !match1 && '75vw',
            // opacity: 0.9
            filter: 'contrast(.7) brightness(1)'

          }}
        />}
      </div>}
      {!match5 && <HeaderLogin />}
      {!loading && <div style={{
        height: '100vh',
        backgroundColor: 'white',
        position: !match2 && 'absolute',
        right: '0',
        width: !match1 ? '25vw' : match2 && '100vw',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: match2 && 'center',
        alignItems: 'center',
        overflowX: 'hidden',
        overflowY: 'auto'
      }}>
        <div style={{
          width: '100%',
          height: !match5 && '80%' || '700px',
          minHeight: match5 && '700px',
          marginTop: '50px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-evenly',

        }}>
          <div className='divimage' style={{ height: match4 && '100%' || '250px', }}>
            <img style={{ width: 'auto', height: '250px', margin: match4 && '20px' }} src={'/images/WebtransLogo.png'} className='image' alt='shotLogo' />
          </div>
          <div className='form' style={{ paddingBottom: '50px' }}>
            <div style={{}}>
              <M_InputTextField
                iconStart={<EmailIcon style={{ marginRight: '10px', color: 'var(--color-grey)' }} />}
                label={t("textFieldEmailLabel")}
                type={"text"}
                onChange={e => setEmail(e.target.value)}
              />
              <M_InputTextField
                iconStart={<KeyIcon style={{ marginRight: '10px', color: 'var(--color-grey)' }} />}
                label={t("textFieldPasswordLabel")}
                type={"password"}
                onChange={e => setPassword(e.target.value)}
              />
              <br />
              <div > <div style={{ cursor: 'pointer', fontSize: '12px', }} onMouseEnter={(e) => { e.currentTarget.style.textDecorationLine = 'underline' }} onMouseLeave={(e) => { e.currentTarget.style.textDecorationLine = 'none' }} onClick={() => { setForgotPass(true) }}>Forgot Password?</div></div>
              <br />
              <span style={{ display: 'flex', justifyContent: 'center', }}>
                <M_Button
                  hoverEffect
                  width={140}
                  label={t("LoginButtonName")}
                  labelColor={'var(--color-white)'}
                  backgroundColor={'var(--color-blue)'}
                  onClick={() => handleSubmit()}
                />
              </span>
            </div>
          </div>
        </div>

        <div style={{
          position: !match5 && 'absolute',
          bottom: '0',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%'
        }}>
          <IconButton style={{ height: '80px', }} disableRipple={true} >
            <img src={`/images/Logo-devlop.png`} alt="logoDevlop" width={'180px'} />

          </IconButton>
          <div style={{

            bottom: '0',
            display: 'flex',
            justifyContent: 'center',
            height: '50px',
            width: '100%',
            backgroundColor: 'var(--color-grey-light)'
          }}>
            <div style={{ display: 'flex', }}>
              {companyButtons.map((el, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <M_Button
                    tooltip={el.label}
                    hoverEffect={false}
                    none
                    icon={<img
                      src={el.src}
                      alt={el.label}
                      color='red'
                      className={el.className}
                      style={{
                        width: '20px',
                        filter: 'invert(100%) sepia(85%) saturate(4876%) hue-rotate(357deg) brightness(92%) contrast(85%)'
                      }}
                    />}
                    onClick={() => onClickButton(el.link)}
                  />
                  {el.label === "Linkedin" && <div style={{ fontSize: '12px', fontWeight: 'bold' }}> devlop.systems </div>}
                  {el.label === "Youtube" && <div style={{ fontSize: '12px', fontWeight: 'bold' }}> @devlopsystems </div>}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>}

      <div style={loading ? { position: 'absolute', height: '100vh', width: '100%', zIndex: '5000000', top: '55px', backgroundColor: 'var(--color-grey-light)', overflow: 'hidden' } : { position: 'absolute', height: '100%', width: '100%', display: 'none' }}>
        <LoadingBar />
      </div>
      <M_MessageBoard
        open={forgotPass}
        onClose={() => setForgotPass(false)}
        title={'Forgot Password?'}
        body={
          <>
            <div style={{ margin: '20px' }}>
              Enter the email associated to your account.
            </div>
            <div style={{ margin: '30px' }}>
              <M_InputTextField
                label={t("textFieldEmailLabel")}
                value={email || ''}
                type={"text"}
                onChange={e => setEmail(e.target.value)}
              />
            </div>
          </>
        }
        footer={
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-red)'} onClick={() => setForgotPass(false)} label={t("ButtonCancel")} />
            <M_Button hoverEffect normal labelColor={'white'} backgroundColor={'var(--color-green)'} onClick={onForgotPass} label={t("ButtonConfirm")} />
          </span>
        }
      />
    </div>
  )
}